import { gql } from '@apollo/client';

export const ADMIN_TRANSFER_CB_TEAM_OWNERSHIP = gql`
  mutation AdminTransferCbTeamOwnership(
    $input: AdminTransferCbTeamOwnershipInput!
  ) {
    adminTransferCbTeamOwnership(input: $input) {
      teamId
      moved {
        key
        count
      }
      steps {
        step
        ok
        detail
      }
    }
  }
`;
